import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import ElementPro from '../components/ElementPro';
import { Link } from 'react-router-dom';

const Professionnel = ({ professionnels, status }) => {
   
    
    if (status === 'loading') {
        // Skeleton Loading State
        return (
            <div className="space-bloc gray-background">
                <div className="container">
                    <div className="row">
                        {/* Colonne gauche */}
                        <div className="col-md-6">
                            <div className="text-professionnels">
                                <Skeleton width={150} height={20} />
                                <br />
                                <Skeleton width={100} height={10} className="separator" />
                            </div>
                            <h2>
                                <Skeleton width="80%" height={30} />
                            </h2>
                            <p>
                                <Skeleton width="90%" height={20} count={3} />
                            </p>
                            <div className="elements-pro">
                                {[...Array(3)].map((_, index) => (
                                    <div key={index} className="skeleton-element" style={{ marginBottom: '15px' }}>
                                        <Skeleton circle width={50} height={50} />
                                        <div style={{ marginLeft: '10px', display: 'inline-block' }}>
                                            <Skeleton width="60%" height={20} />
                                            <Skeleton width="80%" height={15} style={{ marginTop: '5px' }} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Colonne droite */}
                        <div className="col-md-6">
                            <Skeleton className="professionnels-photo" width="100%" height={300} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Render State
    if (status !== 'loading' && professionnels.type) {
        return (
            <div className="space-bloc gray-background">
                <div className="container">
                    <div className="row">
                        {/* Colonne gauche */}
                        <div className="col-md-6">
                            <div className="text-professionnels border-separator pb-24">
                                {professionnels.type}
                                {/* <br />
                                <img src="/images/vector-separator.png" alt="Separator" className="separator" /> */}
                            </div>
                            <h2 className='grey500 mb-0'>{professionnels?.title}</h2>
                            <p className='body grey66 mt-16 mb-0'>{professionnels?.description}</p>
                            <div className="elements-pro  mt-40">
                                {professionnels?.elements?.map((element, index) => (
                                    <ElementPro key={index} element={element} />
                                ))}
                            </div>
                            <div className='bloc-cta mt-40'>
                                <Link to="/Espace-prestataire" className='twyny-cta-list'>
                                    <button className=" twyny-cta-primary">Découvrez notre offre Pro</button>
                                </Link>

                                <Link to="/registerPrestataire" className='twyny-cta-list'>
                                    <button className="mt-xs-8 twyny-cta-secondary">Créez votre compte pro</button>
                                </Link>
                            </div>
                        </div>

                        {/* Colonne droite */}
                        <div className="col-md-6">
                            <div className="professionnels-photo-container">
                                <img
                                    src={`${process.env.REACT_APP_FILE_URL}/${professionnels?.photo}`}
                                    className="professionnels-photo"
                                    alt={professionnels?.title}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Fallback
    return null;
};

export default Professionnel;
